import { Icon } from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import CategoryList from "components/canais/canais";
import { ArrowRightAlt, Search } from "@mui/icons-material";
import { useEffect, useState } from "react";
import SectionCategoryDetails from "components/sectionCategoryDetails/sectionCategoryDetails";
import { InstitutionalResponse, getInstitutional } from "services/PageService";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const TipsGeral: React.FC = () => {
  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [institutional, setInstitutional] =
    useState<InstitutionalResponse | null>(null);

  const urlBase = process.env.REACT_APP_BACKEND_API_URL;
  const [banner, setBanner] = useState("");
  const [data, setData] = useState<any>();

  const fetchInstitutional = async () => {
    try {
      const data = await getInstitutional(14);
      setInstitutional(data);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    }
  };

  useEffect(() => {
    if (institutional) {
      setBanner(
        `${urlBase}/storage/images/institutional/banners/${
          institutional?.banners?.find((e) => e.name == "Banner dicas")
            ?.banner_path
        }`
      );
      setData({
        descriptionCategory:
          institutional?.texts?.find((e) => e.name == "Descrição dicas")
            ?.text ?? "",
        urlCategory:
          institutional?.videos?.find((e) => e.name == "Video dicas")
            ?.video_path ?? "",
      });
    }
  }, [institutional]);

  useEffect(() => {
    fetchInstitutional();
  }, []);

  return (
    <div className="flex flex-col items-center mt-5 p-1">
      <div
        className="flex mb-2 justify-center w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] h-96 bg-cover rounded-3xl bg-blend-darken bg-center"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <span className="flex bg-black bg-opacity-50 w-full justify-center font-semibold text-5xl py-44 brightness-100 text-white rounded-3xl">
          {institutional?.texts?.find((e) => e.name == "Titulo do banner")
            ?.text ?? ""}
        </span>
      </div>
      <span className="w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
        <Link to={"/"}>Home</Link> &gt; <Link to={"/dicas-geral"}>Dicas</Link>
      </span>
      {/* video-card */}

      <SectionCategoryDetails data={data} />

      <div className="flex flex-col mb-10 px-4 md:px-0 lg:flex-row w-full gap-x-10 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
        <div className="w-100">
          <div className="flex-row justify-end mt-1">
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-start lg:justify-between">
              <div className="flex items-center mb-[-18px] md:mb-0">
                <span className="text-sm md:text-base"></span>
              </div>
              <div className="flex gap-2 xl:gap-6">
                <div className="flex items-end gap-x-2 px-4 mt-5 bg-white dark:bg-gray-400 rounded-full border border-gray-200 w-full h-full flex flex-row items-center gap-x-2 pr-1">
                  <input
                    className="text-black bg-transparent border-transparent w-full overflow-hidden resize-none focus:rounded-l-full"
                    maxLength={42}
                    placeholder="Procurar por..."
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                  <div
                    onClick={() => setSearch(searchValue)}
                    className="flex justify-center items-center h-9 w-10 bg-primary-600 rounded-full shadow-md hover:bg-opacity-70 cursor-pointer"
                  >
                    <Icon
                      className="text-white"
                      component={Search}
                      fontSize="medium"
                    />
                  </div>
                </div>

                {/* <button className="flex items-center rounded-full h-12 dark:bg-gray-600 dark:text-white dark:hover:bg-gray-300 gap-x-2 px-4 md:px-8 mt-5 bg-white text-primary-700 hover:bg-primary-300 hover:text-white shadow-sm">
                    Mais Recentes
                    <Icon
                      component={KeyboardArrowDownOutlinedIcon}
                      fontSize="small"
                    />
                  </button>
                  <button className="rounded-full text-sm md:text-base h-12 px-4 md:px-8 mt-5 bg-primary-800 dark:hover:bg-gray-300 text-white hover:bg-primary-500 shadow-sm">
                    Enviar Dica
                  </button>

                   */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex sm:px-0 w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[90rem]">
        <div className="mt-1">
          <CategoryList channelId={1} search={search} />
        </div>
      </div>
    </div>
  );
};

export default TipsGeral;
